import axios from 'axios'
import { backendLink } from '@/main'
import type { ApiResponse, DataFile, FormInfo } from '@/interfaces'

export class ItemWrapper<T> {

    private readonly route: string;

    constructor(route: string) {
        this.route = `${backendLink}/data/${route}`;
    }

    async getItems(): Promise<T[]> {
        return this.callToApi<T[]>("index.php");
    }

    async addItem(data: DataFile): Promise<ApiResponse> {
        return this.postToApi("add.php", data, {});
    }

    async getInfo(): Promise<FormInfo> {
        return this.callToApi<FormInfo>("info.php");
    }

    private async postToApi(route: string, data: DataFile, headers: any): Promise<ApiResponse> {
        const response = await axios.post(`${this.route}/${route}`, data, headers);

        return response?.data;
    }

    private async callToApi<T>(route: string): Promise<T> {
        const response = await axios.get(`${this.route}/${route}`);

        return response?.data;
    }
}